import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../../../common/utils/froala.utils';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { LoaderService } from '../../../../common/services/loader.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';

import { coReviewViewModel } from '../../../../models/comodel/coreviewviewmodel.model';

@Component({
    selector: 'co-edit-letter',
    templateUrl: './co-edit-letter.component.html',
    styleUrls: ['./co-edit-letter.component.scss'],
    standalone: false
})
export class CoReviewLetterComponent implements OnInit, OnDestroy {

    @Input() coInstanceId: string;
    @Input() coreReviewModel: coReviewViewModel;
    @Output() setCurrentView = new EventEmitter<string>();
    @Output() setCoreReviewModel = new EventEmitter<coReviewViewModel>();
    subscription = new Subscription();

    reviewModel: coReviewViewModel;

    private _froalaOptions: any = null;
    get froalaOptions(): any {
        if (!this._froalaOptions) {
            let conf = window["PdfConfig"] as any;
            let key = (conf != null) ? conf.editorLicenseKey : "";
            this._froalaOptions = applyFroalaAriaFix({
                heightMax: 600,
                height: 600,
                heightMin: 150,
                key: key,
                fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '22', '24', '26', '26.5', '27', '30', '60', '72', '96'],
                fontFamily: {
                    'Arial,Helvetica,sans-serif': 'Arial',
                    'Georgia,serif': 'Georgia',
                    'Impact,Charcoal,sans-serif': 'Impact',
                    'Tahoma,Geneva,sans-serif': 'Tahoma',
                    "'Times New Roman',Times,serif": 'Times New Roman',
                    'Verdana,Geneva,sans-serif': 'Verdana',
                    'Gabriola,sans-serif': 'Gabriola'
                },
                toolbarButtons: ["fullscreen", "html", "|", "undo", "redo", "|", "bold", "italic", "underline", 'strikeThrough', "|", "formatOL", "formatUL", "|", "align", "fontFamily", "fontSize", "paragraphFormat", "insertLink", "|", "outdent", "indent", "clearFormatting", "insertTable", "color"]
            });
        }
        return this._froalaOptions;
    }

    constructor(
        private activeRoute: ActivatedRoute,
        public chiefsOrderService: ChiefsOrderService,
        private readonly loaderService: LoaderService,
        private router: Router,
        private subHeaderService: SubHeaderService
    ) { }

    ngOnInit() {
        this.reviewModel = this.coreReviewModel;
    }

    ngOnDestroy(): void {
        if (this.subscription)
            this.subscription.unsubscribe();
    }

    saveLetter(): void {
        this.loaderService.toggleLoader(true);
        this.coreReviewModel.currentReview.letter.htmlContent = stripFroalaWatermark(this.coreReviewModel.currentReview.letter.htmlContent);
        const res$ = this.chiefsOrderService.saveletterfromreview(this.coreReviewModel).pipe(finalize(() => {
            this.subscription.add(res$)
        })).subscribe(response => {
            this.loaderService.toggleLoader(false);
            this.setCoreReviewModel.emit(response);
            this.setCurrentView.emit('review-chiefsorder');
        }, error => {
            this.loaderService.toggleLoader(false);
            console.log(error)
        });
    }

}
